// Integração leve com o Google Analytics 4 (gtag.js).
// Não faz nada se REACT_APP_GA_MEASUREMENT_ID não estiver configurado.

let initialized = false;

export function initGA() {
  const measurementId = process.env.REACT_APP_GA_MEASUREMENT_ID;
  if (!measurementId || initialized) return;

  const script = document.createElement('script');
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${measurementId}`;
  document.head.appendChild(script);

  window.dataLayer = window.dataLayer || [];
  window.gtag = function gtag() { window.dataLayer.push(arguments); };
  window.gtag('js', new Date());
  // send_page_view desativado: cada rota do React Router é enviada manualmente
  window.gtag('config', measurementId, { send_page_view: false });

  initialized = true;
}

export function trackPageview(path) {
  if (!window.gtag) return;
  window.gtag('event', 'page_view', { page_path: path });
}
